import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";

const ImageCarousel = ({ children, selectedItem, onChange, thumbWidth }) => (
  <Carousel selectedItem={selectedItem}
    onChange={onChange}
    thumbWidth={thumbWidth}>
    {children}
  </Carousel>
);

export default ImageCarousel;
